module.exports = __webpack_public_path__ + "6876dcf962019ebc297a1fb6431c24ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Marquise.png
// module id = 789
// module chunks = 0